import React from 'react';
import TypeWriter from 'typewriter-effect';
import bannerImage from '../assets/img/logo/banner2.jpg';
import {HouseContex0t} from './HouseContext';
import {useContext, useState} from 'react';
import { Link } from 'react-router-dom';

import {RiSearch2Line} from 'react-icons/ri';
import { HouseContext } from './HouseContext';

const Banner = () => {
  const [isLoading, setIsLoading] = useState(false);
  
  const {handleClick} = useContext(HouseContext)
  return (
    <>
     <section className="back bg-gray-800 dark:bg-gray-800 text-white dark:text-gray-100 mt-10 max-auto" style={{ 
        backgroundImage: `url(${bannerImage})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundSize: "cover",
        height: "67vh",
        width: "100%",
        }}>

      <div className="container mx-auto mt-20 h-full flex flex-col justify-center">
        <div className="items-center">
          <h1 className=' font-medium text-center mx-auto text-5xl md:text-7xl lg:text-8xl'>
            Your Compass in
          </h1>
          <h1 className=' font-medium text-center mx-auto text-5xl md:text-7xl lg:text-8xl'>
            Real Estate
          </h1>

          <div className="flex justify-center  mt-6 space-x-7">
            <Link to='/buy'>
            <button
                className="px-4 py-2 font-bold tracking-wide text-green-500 capitalize transition-colors duration-200 transform bg-white border border-green-500 rounded-md hover:bg-green-500 hover:text-white focus:outline-none focus:bg-blue-50 w-44 flex items-center justify-center"
                onClick={() => {
                  setIsLoading(true);
                  handleClick();
                  setTimeout(() => {
                    setIsLoading(false);
                  }, 1000);
                }}
              >
                {isLoading ? (
                  <RiSearch2Line className="animate-spin mr-2" />
                ) : (
                  <>
                    <span className="mr-2 text-[20px]">BUY</span>
                    
                  </>
                )}
              </button>


            </Link>
            <Link to='/rent'>
            <button
                className="px-4 py-2 font-bold tracking-wide text-green-500 capitalize transition-colors duration-200 transform bg-white border border-green-500 rounded-md hover:bg-green-500 hover:text-white focus:outline-none focus:bg-blue-50 w-44 flex items-center justify-center"
                onClick={() => {
                  setIsLoading(true);
                  handleClick();
                  setTimeout(() => {
                    setIsLoading(false);
                  }, 1000);
                }}
              >
                {isLoading ? (
                  <RiSearch2Line className="animate-spin mr-2" />
                ) : (
                  <>
                    <span className="mr-2 text-[20px]">RENT</span>
                    
                  </>
                )}
              </button>
            </Link>
          </div>
          <div className="flex justify-center mt-6">
          
            </div>
         
          

            <div className='Writer text-center text-white text-2xl lg:text-[24px] pt-2'>
              <TypeWriter 
                options ={{
                  strings: ['Find new & featured property located in your local city.', 'Urban Compass Realty is a real estate agency based in Manila, Philippines', 'with large and top-grade real estate offers located within and outside the metro.','The company is manned by a specialized team of','licensed and registered real estate agents,','equipped with all the information a client needs when buying or selling', 'a property and/or leasing the same','and the team is meticulously trained to guide their clients', 'throughout the entire buying and/or leasing process.' ],
                  autoStart: true,
                  loop: true.valueOf,
                }}
              />
            </div>
        </div>
      </div>

     
      

      </section>
    </>
  );
};

export default Banner;
